<template>
  <div class="update-basic">
    <div class="item-container">
      <div class="col-item" v-if="authStore.hasPermission(PermissionConst.SYAIN_MASTER_DETAIL_ALL)">
        <b class="title required">所属</b>
        <select-box :options="options.mst_syozoku" v-model="form.mst_syozoku_id"
          :error="getError(form, 'mst_syozoku_id')"></select-box>
      </div>
      <div class="col-item">
        <b class="title required">勤務状況</b>
        <select-box :options="kinmuStatusType" v-model="form.kinmu_status_type"
          :error="getError(form, 'kinmu_status_type')"></select-box>
          <b>(必須）現在の勤務状況を指定して下さい</b>
      </div>
      <div class="col-item">
        <b class="title">退職日</b>
        <date-picker v-model="form.taisyoku_date" :error="getError(form, 'taisyoku_date')"></date-picker>
        <div>
          <b>(任意）退職する社員の退職日を指定して下さい</b>
          <br>
          <b>最終利用可能日も併せて入力して下さい</b>
        </div>
      </div>
      <div class="col-item">
        <b class="title">最終利用可能日</b>
        <date-picker v-model="form.last_available_day" :error="getError(form, 'last_available_day')"></date-picker>
        <div>
          <b>(任意）ACLisにログインできる最終日を指定して下さい</b>
          <br>
          <b>退職日も併せて入力して下さい</b>
        </div>
      </div>
      <div class="col-item">
        <b class="title required">役職</b>
        <select-box :options="options.mst_yakusyoku" v-model="form.mst_yakusyoku_id"
          :error="getError(form, 'mst_yakusyoku_id')"></select-box>
          <b>(必須）該当する役職を指定して下さい</b>
      </div>
      <div class="col-item">
        <b class="title required">権限ロール</b>
        <template v-if="isAdminRole">
          <input-text type="text" :disabled="true" v-model="form.role_name" />
        </template>
        <template v-else>
          <select-box :options="options.mst_role" v-model="form.mst_role_id"
            :error="getError(form, 'mst_role_id')"></select-box>
        </template>
        <b>(必須）該当する権限を指定して下さい</b>
      </div>
      <div class="col-item">
        <b class="title">入社日</b>
        <date-picker v-model="form.nyuusya_date" :error="getError(form, 'nyuusya_date')" :disabled="true"></date-picker>
      </div>
      <div class="col-item">
        <b class="title">有休付与基準日</b>
        <date-picker v-model="form.yuukyuu_reference_date" :error="getError(form, 'yuukyuu_reference_date')" :disabled="form.has_yuukyuu_fuyu"></date-picker>
        <b v-if="!form.has_yuukyuu_fuyu">※ 転籍などで入社日以外の年月日を有休付与の基準日にする場合に指定して下さい</b>
        <b v-if="form.has_yuukyuu_fuyu">※ 既に有給付与が行われているため変更できません。</b>
      </div>
      <div class="col-item">
        <b class="title">社員番号</b>
        <input-text type="text" v-model="form.staff_code" :error="getError(form, 'staff_code')"
          placeholder="例）　0000000000"></input-text>
          <b>(任意）</b>
      </div>
      <div class="col-item">
        <b class="title required">氏名</b>
        <input-text type="text" v-model="form.staff_name" :error="getError(form, 'staff_name')"
          placeholder="例）　管理　太郎"></input-text>
          <b>(必須）</b>
      </div>
      <div class="col-item">
        <b class="title">フリガナ</b>
        <input-text type="text" v-model="form.staff_kana" :error="getError(form, 'staff_kana')"
          placeholder="例）　カンリ　タロウ"></input-text>
          <b>(任意）</b>
      </div>
      <div class="col-item">
        <b class="title required">性別</b>
        <input-radio :options="genderType" v-model="form.gender_type"
          :error="getError(form, 'gender_type')"></input-radio>
          <b>(必須）</b>
      </div>
      <div class="col-item">
        <b class="title">生年月日</b>
        <date-picker v-model="form.birthday_date" :error="getError(form, 'birthday_date')"></date-picker>
        <b>(任意）</b>
      </div>
      <div class="col-item">
        <b class="title">郵便番号</b>
        <input-text type="text" v-model="form.zip_code" @blur="form.zip_code = ConvertUtil.removeNonNumeric(form.zip_code, true)"
          :error="getError(form, 'zip_code')" placeholder="例）　000-0000"></input-text>
        <span class="annotation">※-(ハイフン)なしも可</span>
        <b>(任意）</b>
      </div>
      <div class="col-item">
        <b class="title">住所</b>
        <input-text type="text" class="address" v-model="form.address" :error="getError(form, 'address')"
          placeholder="例）　〇〇県△△市□□区××町1-1 〇〇ビル101"></input-text>
          <b>(任意）</b>
      </div>
      <div class="col-item">
        <b class="title">メールアドレス</b>
        <input-text type="text" v-model="form.email" :error="getError(form, 'email')"
          placeholder="例）　email@example.com"></input-text>
          <b>(任意）</b>
      </div>
      <div class="col-item">
        <b class="title">連絡先電話番号（固定）</b>
        <input-text type="text" v-model="form.tel" @blur="form.tel = ConvertUtil.removeNonNumeric(form.tel, true)"
          :error="getError(form, 'tel')" placeholder="例）　00-0000-0000"></input-text>
        <span class="annotation">※-(ハイフン)なしも可</span>
        <b>(任意）</b>
      </div>
      <div class="col-item">
        <b class="title">連絡先電話番号（携帯）</b>
        <input-text type="text" v-model="form.keitai_tel" @blur="form.keitai_tel = ConvertUtil.removeNonNumeric(form.keitai_tel, true)"
          :error="getError(form, 'keitai_tel')" placeholder="例）　000-0000-0000"></input-text>
        <span class="annotation">※-(ハイフン)なしも可</span>
        <b>(任意）</b>
      </div>
      <div class="col-item">
        <b class="title">緊急連絡先名</b>
        <input-text type="text" v-model="form.emergency_name" :error="getError(form, 'emergency_name')"
          placeholder="例）　父親"></input-text>
          <b>(任意）</b>
      </div>
      <div class="col-item">
        <b class="title">緊急連絡先 電話番号</b>
        <input-text type="text" v-model="form.emergency_tel"
          @blur="form.emergency_tel = ConvertUtil.removeNonNumeric(form.emergency_tel, true)" :error="getError(form, 'emergency_tel')"
          placeholder="例）　000-0000-0000"></input-text>
        <span class="annotation">※-(ハイフン)なしも可</span>
        <b>(任意）</b>
      </div>
      <div class="col-item">
        <b class="title">免許証の有無</b>
        <input-radio :options="driversLicense" v-model="form.is_drivers_license"
          :error="getError(form, 'is_drivers_license')"></input-radio>
          <b>(必須）</b>
      </div>
      <div class="col-item" v-show="form.is_drivers_license">
        <b class="title required">免許証の種類</b>
        <input-text type="text" v-model="form.drivers_license" :error="getError(form, 'drivers_license')"
          placeholder="種類名称を入力"></input-text>
          <b>(必須）免許証の種類を入力して下さい</b>
      </div>
      <div class="col-item">
        <b class="title">保険証番号</b>
        <input-text type="text" v-model="form.hokensyou_no" @blur="form.hokensyou_no = ConvertUtil.removeNonNumeric(form.hokensyou_no)"
          :error="getError(form, 'hokensyou_no')" placeholder="例）　00000000"></input-text>
          <b>(任意）</b>
      </div>
      <div class="col-item">
        <b class="title">雇用保険</b>
        <input-text type="text" v-model="form.koyou_hoken" :error="getError(form, 'koyou_hoken')"
          placeholder="例）　00000000"></input-text>
          <b>(任意）</b>
      </div>
      <div>
        <div class="col-item">
          <b class="title">Web明細</b>
          <input-radio :options="webMeisaiFixType" v-model="form.is_web_meisai"
            :error="getError(form, 'is_web_meisai')"></input-radio>
            <b>(必須）Web明細に対応しているかどうかを指定して下さい</b>
        </div>
        <div v-show="!form.is_web_meisai" class="col-item">
          <b class="title required">未対応理由</b>
          <input-textarea v-model="form.web_mitaiou_notes" :error="getError(form, 'web_mitaiou_notes')"
            placeholder="未対応理由を入力"></input-textarea>
            <b>(必須）未対応理由を入力して下さい</b>
        </div>
      </div>
      <div class="col-item">
        <b class="title">資格</b>
        <input-textarea v-model="form.shikaku_notes" :error="getError(form, 'shikaku_notes')"></input-textarea>
        <b>(任意）資格情報を入力して下さい</b>
      </div>
      <div class="col-item">
        <b class="title">異動歴</b>
        <input-textarea v-model="form.idoureki_notes" :error="getError(form, 'idoureki_notes')"></input-textarea>
        <b>(任意）過去の就業場所異動履歴を入力して下さい</b>
      </div>
      <div class="col-item">
        <b class="title">備考</b>
        <input-textarea v-model="form.notes" :error="getError(form, 'notes')"></input-textarea>
        <b>(任意）</b>
      </div>

      <div class="col-item">
        <div class="title"><b>その他休日</b></div>
        <div class="data flex-align-center">
          <template v-if="!form.sonota_kyuujitus || form.sonota_kyuujitus.length < 1">
            <div class="col-item">
              <p>無し</p>
              <div class="row-button">
                <i class="fa-solid fa-circle-plus" @click="addRow()"></i>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="sonota" v-for="(item, index) in form.sonota_kyuujitus" :key="index">
              <div class="head"><b>その他休日{{ (index + 1) }}</b></div>
              <div class="item">
                <p>区分</p>
                <select-box :options="sonotaKyuujitsuType" v-model="item.sonota_kyuujitsu_type"></select-box>
              </div>
              <div class="date flex">
                <div class="item">
                  <p>開始日</p>
                  <date-picker v-model="item.start_date" class="table-cell"
                    :error="getError(item, 'start_date')"></date-picker>
                </div>
                <div class="item">
                  <p>終了日</p>
                  <date-picker v-model="item.end_date" class="table-cell"
                    :error="getError(item, 'end_date')"></date-picker>
                </div>
              </div>

              <div class="item row-button">
                <i class="fa-solid fa-delete-left" @click="removeTableRow(form.sonota_kyuujitus, index)"></i>
                <template v-if="(index + 1) == form.sonota_kyuujitus.length">
                  <i class="fa-solid fa-circle-plus" @click="addRow()"></i>
                </template>
              </div>
            </div>
          </template>
        </div>
        <b>(任意）産休等、その他休日の期間を入力して下さい</b>
      </div>

    </div>
    <!-- /baseinfo -->
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { useForm } from "@/composable/form/form";
import { dateFormat } from "@/filters/common";
import { useTableRow } from "@/composable/common/tablerow";
import { SonotaKyuujitsu } from "@/types/Syain";
import OptionConst from '@/const/SyainMaster/Option';
import { DetailInputData, SyainOptions } from "@/types/Syain";
import { useAuthStore } from "@/store/auth";
import { PermissionConst } from '@/const/Permission';
import { ConvertUtil } from "@/utils/ConvertUtil";

export default defineComponent({
  props: {
    form: {
      type: Object as () => DetailInputData,
      default: null
    },
    options: {
      type: Object as () => SyainOptions,
      default: null
    },
    isEdit: {
      type: Boolean,
    },
  },
  watch: {

  },
  setup(props) {
    // 初期処理
    const { getError } = useForm();
    const { addRowNoRef, removeTableRow } = useTableRow();
    const authStore = useAuthStore()

    // 行追加
    const addRow = () => {
      let row
      row = {
        user_id: props.form.user_id,
        sonota_kyuujitsu_type: props.form.sonota_kyuujitus
      } as SonotaKyuujitsu
      addRowNoRef(props.form.sonota_kyuujitus, row)
    }

    const isAdminRole = computed(() => {
      return props.isEdit && !props.options.mst_role.some(v => v.val === props.form.mst_role_id)
    })

    return {
      getError,
      dateFormat,
      addRow,
      removeTableRow,
      "driversLicense": OptionConst.DRIVERS_LICENSE,
      "genderType": OptionConst.GENDER_TYPE,
      "webMeisaiFixType": OptionConst.WEB_MEISAI_FIX_TYPE,
      "kinmuStatusType": OptionConst.KINMU_STATUS_TYPE,
      "sonotaKyuujitsuType": OptionConst.SONOTA_KYUUJITSU_TYPE,
      authStore,
      PermissionConst,
      isAdminRole,
      ConvertUtil
    };
  },
});
</script>

<style lang="scss" scoped>
@import '@scss/components/syain-detail.scss';
</style>
